module.exports = __webpack_public_path__ + "media/images/game_icon/en/BC3049-942e95ed19dc21714802f665b921ae8c.png";